module.exports = __webpack_public_path__ + "img/MK_Screen_1.d2d441fb.jpg";